import { render, staticRenderFns } from "./FencingTable.vue?vue&type=template&id=180d1567"
import script from "./FencingTable.vue?vue&type=script&lang=ts"
export * from "./FencingTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports